var mouseOutTimer; // timer used to delay hiding of menu after mouse leaves
var mouseOutHideDelay = 500; // time (in ms) before menu is closed after mouse leaves
var currently_opening = false; // current visibility state of menu
var timer = null; // Move the timer declaration to a global scope
var searchModal = document.getElementById('container-search');

function showMegamenuItem(menuItemEl) {
  if (!menuItemEl) return;
  let menuLinkHoverDuration = 150;

  if (searchModal.hasAttribute('open')) {
      searchModal.removeAttribute('open');
      searchModal.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove("overflow-hidden");
  }
  if (menuItemEl?.dataset?.handle) {
    let megamenuId = "megamenu-" + menuItemEl.dataset.handle.trim();
    let megamenuItemEl = document.getElementById(megamenuId);

    if (!megamenuItemEl) {
      hideAllMenuItems();
      clearTimeout(timer);
      return;
    }

    let buttonEl = menuItemEl.closest("li").querySelector("button");

    let timerHoverDuration = menuIsVisible() ? 0 : menuLinkHoverDuration;

    // Set timeout to control the hover behavior
    timer = setTimeout(function () {
      // prepare menu for animation
      document.body.classList.add("megamenu--isActive");

      // show mega menu item
      setTimeout(function () {
        hideAllMenuItems();
        menuItemEl.classList.add("megamenu--current");
        megamenuItemEl.classList.add("megamenu--isVisible");
        if (buttonEl) {
          buttonEl.setAttribute("aria-expanded", "true");
        }
        currently_opening = false;
      }, 250);
    }, timerHoverDuration);
  }
}

// Function to hide all megamenu items
function hideAllMenuItems() {
  const allMegamenuItems = document.querySelectorAll(
    ".megamenu--current, .megamenu--isVisible"
  );
  allMegamenuItems.forEach((item) => {
    item.classList.remove("megamenu--current", "megamenu--isVisible");
  });

  const allButtons = document.querySelectorAll(
    "header .list-menu--inline .toggle-megamenu-button[aria-expanded='true']"
  );
  allButtons.forEach((button) => {
    button.setAttribute("aria-expanded", "false");
  });

  document.body.classList.remove("megamenu--isActive");
}

// Check if menu is currently visible
function menuIsVisible() {
  return document.querySelector(".megamenu--isVisible") !== null;
}

// Define a function to get focusable elements
function getFocusableElements(element) {
  return element.querySelectorAll(
    'a, button, input, [tabindex]:not([tabindex="-1"])'
  );
}

function getColumnElements(element) {
  // Get all the megamenu columns
  let columns = element.querySelectorAll("fostr-megamenu-column");

  // Get the last column
  let lastColumn = columns[columns.length - 1];

  // Get all focusable elements inside the last column
  let focusableElements = getFocusableElements(lastColumn);

  // Get the last focusable element
  lastFocusableElement = focusableElements[focusableElements.length - 1];

  // Check if focusable elements exist
  if (!focusableElements.length) return;
}

function triggerKeydownHandler(e) {
  // Hide the menu when keyboard user tabs out of it or presses Escape
  if (
    (e.key === "Tab" && !e.shiftKey && e.target === lastFocusableElement) ||
    e.key === "Escape"
  ) {
    hideAllMenuItems();

    // Move focus back to the menu toggle button if Escape was pressed
    if (e.key === "Escape") {
      let toggleButton = document.querySelector(
        ".toggle-megamenu-button[aria-expanded='true']"
      );
      if (toggleButton) {
        toggleButton.focus();
      }
    }
  }
}

window.addEventListener("DOMContentLoaded", function (e) {
  var bodyClass = "megamenu--isActive";
  var mainNavTarget = "header .megamenu-li";
  var toggleButtons = document.querySelectorAll(".toggle-megamenu-button");
  var triggerContainer = document.querySelectorAll(mainNavTarget);
  var lastFocusableElement = null;
  var megamenuElements = document.querySelectorAll("fostr-megamenu-item");

  toggleButtons.forEach((triggerButton) => {
    triggerButton.addEventListener("click", function (e) {
      let ariaControls = e.target
        .getAttribute("aria-controls")
        .replace("megamenu-", "");
      let aTarget = document.querySelector(`a[data-handle="${ariaControls}"]`);
      let megamenuItem = document.querySelector(
        `fostr-megamenu-item#${e.target.getAttribute("aria-controls")}`
      );
      currently_opening = true;
      showMegamenuItem(aTarget);
      lastFocusableElement = getColumnElements(megamenuItem);
    });
  });

  // Hide megamenu when mouse leaves the menu item
  triggerContainer.forEach((triggerElement) => {
    triggerElement.addEventListener("mouseleave", function (e) {
      mouseOutTimer = setTimeout(() => {
        hideAllMenuItems();
      }, mouseOutHideDelay);
    });

    triggerElement.addEventListener("mouseover", function (e) {
      if (!e.target.closest(mainNavTarget)) return false;
      currently_opening = true;
      showMegamenuItem(e.target);
      clearTimeout(mouseOutTimer);
    });

    triggerElement.addEventListener("keydown", triggerKeydownHandler);
  });

  window.addEventListener("scroll", function (e) {
    hideAllMenuItems();
  });
  
  megamenuElements.forEach((megamenuElement) => {
    megamenuElement.addEventListener("mouseleave", function (e) {
      hideAllMenuItems();
    });
  });
});
